export default {
    FUND:1,
    CHEQUE:2,
    BANK_ACCOUNT:3,
    FUND_AND_BANK_ACCOUNT:13
}

export const sourceNames = {
    1:{name:"صندوق", icon:"icon mapsa-empty-opened-wallet"},
    2:{name:"چک دریافتی", icon: "icon mapsa-cheque"},
    3:{name:"حساب بانکی", icon:"icon mapsa-bank-1"},
};